import { render, staticRenderFns } from "./OrderICountDocuments.vue?vue&type=template&id=2affa29e&"
import script from "./OrderICountDocuments.vue?vue&type=script&lang=js&"
export * from "./OrderICountDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports